import {Sprite} from 'pixi.js';
import {KeypadView, KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';
import {SpinButtonBaseViewMobile, SpinButtonViewEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {Button, Timer} from '@gongxigames/framework/core';

export class SpinButtonViewMobileLandscape extends SpinButtonBaseViewMobile {
    public static readonly NAME: symbol = Symbol('SpinButtonViewMobileLandscape');

    protected static readonly SETTINGS_PANEL_MENU_CALL_TIMER: number = 500;

    protected _settingsPanelTimer?: Timer;
    protected _isOnHold = false;

    public init(): void {

        this.initGraphicElements();
        this.setupEventsForButtons();
        this.setupSpinButtonTouching();

        this._spinsLeftButton.callback = this.onSpinsLeftButtonClicked.bind(this);
    }

    protected initGraphicElements(): void {
        super.initGraphicElements();

        this.mainSprite.getChildByName('spinButton').visible = true;
        this.mainSprite.getChildByName('spinButtonWithoutHoldSettings').visible = false;

        this._spinsLeftButton = this.mainSprite.getChildByName<Button>('spinsLeftButton');
    }

    public setSprite(name: string): void {
        const previousVisibleState = this._spinButton.visible;

        this._spinButton.visible = false;
        this._spinButton.off('touchstart');
        this._spinButton.off('touchendoutside');
        this._spinButton.off('touchend');

        this._spinButton = this.mainSprite.getChildByName<Button>(name);
        this._spinButton.visible = previousVisibleState;

        this.setupEventsForButtons();
        this.setupSpinButtonTouching();
    }

    public enableSpinButton(): void {
        super.enableSpinButton();

        this.enableSpinsLeftButton();
    }

    public disableSpinButton(): void {
        super.disableSpinButton();

        this.disableSpinsLeftButton();
    }

    public enableSpinsLeftButton(): void {
        this._spinsLeftButton.enable();
    }

    public disableSpinsLeftButton(): void {
        this._spinsLeftButton.disable();
    }

    public initFreeSpins(): void {
        super.initFreeSpins();

        this._spinsLeftButton.visible = true;
        this._spinButton.visible = false;
    }

    public initMainGame(): void {
        super.initMainGame();

        this._spinsLeftButton.visible = false;
        this._spinButton.visible = true;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobileLandscape.NAME];
    }

    protected onHold(): void {
        this._isOnHold = true;
        this.emit(SpinButtonViewEvents.SPIN_BUTTON_HOLD);
    }

    protected setupSpinButtonTouching(): void {
        this._spinButton.on('touchstart', this.onTouchStart.bind(this));
        this._spinButton.on('touchendoutside', this.onTouchEnd.bind(this));
        this._spinButton.on('touchend', this.onTouchEnd.bind(this));
    }

    protected onTouchStart(): void {
        if (!this._spinButton.enabled || !this._holdEnabled) {
            return;
        }

        this._isOnHold = false;
        this._settingsPanelTimer = new Timer(this.onHold.bind(this), SpinButtonViewMobileLandscape.SETTINGS_PANEL_MENU_CALL_TIMER, true);

        this.updateManager.add(this._settingsPanelTimer);
    }

    public onSpinStarted(): void {
        this._isOnHold = false;
    }

    protected onTouchEnd(): void {
        this.updateManager.remove(this._settingsPanelTimer!);
        this._settingsPanelTimer = undefined;
    }

    protected onSpinButtonClicked(): void {
        // if onHold() was called we don't need to call onSpinButtonClicked()
        if (!this._isOnHold) {
            super.onSpinButtonClicked();
        }
    }

    protected onSpinsLeftButtonClicked(): void {
        this.soundPlayer.play('spinclick');
        this.emit(SpinButtonBaseViewMobile.SPINS_LEFT_BUTTON_CLICKED);
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }
}
